import React from 'react';

import { useTimeElapsed } from 'plataforma-fundacao-componentes';
import { secondsToHours } from 'helpers/utils/ParsingUtils';

export interface ICountdownTimer {
  counter: number;
  onProgress?: (counter: number) => void;
  onCompleted?: () => void;
}

export default function CountdownTimer({
  counter,
  onCompleted,
}: ICountdownTimer) {
  const timer = useTimeElapsed(counter, onCompleted);

  const secondsToDays = (second: number) => {
    second = Number(second);

    let days = Math.floor(second / (24 * 3600));
    let hours = Math.floor((second % (3600 * 24)) / 3600);
    let minutes = Math.floor((second % 3600) / 60);
    let seconds = Math.floor((second % 3600) % 60);

    const dDisplay =
      days > 0
        ? days +
          (days === 1 ? ' dia' : ' dias') +
          (hours === 0 && minutes > 0
            ? ' e '
            : hours > 0 || minutes > 0
            ? ', '
            : '')
        : '';
    const hDisplay =
      hours > 0
        ? hours +
          (hours === 1 ? ' hora' : ' horas') +
          (minutes > 0 ? ' e ' : '')
        : '';
    const mDisplay =
      minutes > 0
        ? minutes +
          (minutes === 1 ? ' minuto' : ' minutos') +
          (seconds > 0 ? '' : '')
        : '';
    return days >= 1 ? dDisplay + hDisplay + mDisplay : secondsToHours(second);
  };

  return <span>{secondsToDays(timer)}</span>;
}
